import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getTranslations } from 'api/Languages';
import { fetchWithLanguage } from 'store/helpers';

export const fetchTranslations = fetchWithLanguage('fetchTranslations', getTranslations);

const transltionsSlice = createSlice({
    name: 'transltionsSlice',
    initialState: {
        data: {},
        translationsIsLoading: false,
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchTranslations.pending, state => {
            state.translationsIsLoading = true;
        });
        builder.addCase(fetchTranslations.fulfilled, (state, action) => {
            state.data = action.payload;
            state.translationsIsLoading = false;
        });
    },
});

export const selectTranslations = createSelector([state => state.translationsState.data], data => data.data || {});

export const selectTranslationsIslLoading = createSelector(
    [state => state.translationsState.translationsIsLoading],
    translationsIsLoading => translationsIsLoading,
);
export default transltionsSlice.reducer;
